(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gk-product-details"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gk-product-tabs]').forEach((tabs) => {
  if (tabs.dataset.initialized === 'true') return;
  tabs.dataset.initialized = 'true';

  const buttons = Array.from(tabs.querySelectorAll('[role="tab"]'));
  const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const panelId = button.getAttribute('aria-controls');

      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.id === panelId;
        panel.classList.toggle('is-active', active);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!window.__gkCatalogFiltersV2) {
  window.__gkCatalogFiltersV2 = true;
  const selected = new Map();
  function update(root, filter = selected.get(root.dataset.gkCatalog) || 'all') {
    const buttons = [...root.querySelectorAll('[data-gk-category-filter]')];
    const items = [...root.querySelectorAll('[data-gk-category]')];
    if (!buttons.length) return;
    if (!buttons.some(button => button.dataset.gkCategoryFilter === filter)) filter = 'all';
    selected.set(root.dataset.gkCatalog, filter);
    buttons.forEach(button => { const active = button.dataset.gkCategoryFilter === filter; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
    let count = 0;
    items.forEach(item => { item.hidden = filter !== 'all' && item.dataset.gkCategory !== filter; if (!item.hidden) count++; });
    root.querySelectorAll('.product-list__promo').forEach(item => { item.hidden = filter !== 'all'; });
    const target = root.querySelector('[data-gk-product-count]');
    if (target) {
      let text = count === 1 ? root.dataset.gkCountOne : root.dataset.gkCountMany.replace('999999', String(count));
      if (Number(root.dataset.gkPages) > 1) text += ' ' + root.dataset.gkPageLabel;
      if (target.textContent !== text) target.textContent = text;
    }
    const empty = root.querySelector('[data-gk-filter-empty]');
    if (empty) empty.hidden = count !== 0;
  }
  function init(scope = document) {
    if (scope.matches?.('[data-gk-catalog]')) update(scope);
    scope.querySelectorAll?.('[data-gk-catalog]').forEach(root => update(root));
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-gk-category-filter]');
    const root = button?.closest('[data-gk-catalog]');
    if (root) update(root, button.dataset.gkCategoryFilter);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches('[data-gk-catalog]') || node.querySelector('[data-gk-catalog]')) init(node);
      else if (node.matches('.collection__results, product-list, .gk-category-item, [data-gk-category]') || node.querySelector('[data-gk-category]')) { const root = node.closest('[data-gk-catalog]'); if (root) update(root); }
    }
  }).observe(document.documentElement, {childList:true,subtree:true});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-press"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-press-section]').forEach((section) => {
    const buttons = section.querySelectorAll('[data-press-filter]');
    const cards = section.querySelectorAll('[data-press-card]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.pressFilter;

        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('selected', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.category !== filter;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
if (!window.__gkSearchCountsV3) {
  window.__gkSearchCountsV3 = true;
  function init(scope = document) {
    const summaries = scope.matches?.('[data-gk-search-summary]') ? [scope] : scope.querySelectorAll?.('[data-gk-search-summary]') || [];
    summaries.forEach(async summary => {
      if (summary.dataset.countsLoaded) return;
      summary.dataset.countsLoaded = 'true';
      const currentUrl = new URL(window.location.href);
      const productTerms = summary.dataset.productTerms || summary.dataset.terms || '';
      if (summary.dataset.productOnly === 'true' && currentUrl.searchParams.get('q') !== productTerms) {
        currentUrl.searchParams.set('q', productTerms);
        window.location.replace(currentUrl.toString());
        return;
      }
      const tabs = Array.from(summary.querySelectorAll('[data-search-type]'));
      if (tabs.length < 2) return;
      const counts = await Promise.all(tabs.map(async tab => {
        const target = tab.querySelector('[data-search-type-count]');
        if (!target) return null;
        target.hidden = true;
        try {
          const url = new URL(window.location.href);
          url.pathname = summary.dataset.searchUrl;
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          Array.from(url.searchParams.keys()).forEach(key => {
            if (key.startsWith('filter.')) url.searchParams.delete(key);
          });
          url.searchParams.set('preview_theme_id', summary.dataset.themeId);
          url.searchParams.set('type', tab.dataset.searchType);
          url.searchParams.set('q', tab.dataset.searchType === 'product' ? productTerms : summary.dataset.terms || '');
          const response = await fetch(url.toString(), {headers:{'X-Requested-With':'XMLHttpRequest'}});
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const count = doc.querySelector('[data-search-results-count]')?.getAttribute('data-search-results-count');
          if (count === null || count === undefined || !/^\d+$/.test(count)) return null;
          const panel = document.getElementById(tab.getAttribute('controlled-panel'));
          const sourcePanel = doc.getElementById(tab.getAttribute('controlled-panel'));
          if (panel && panel.hasAttribute('data-load-url')) {
            if (sourcePanel) panel.replaceChildren(...Array.from(sourcePanel.children));
            else if (Number(count) === 0) {
              const empty = document.createElement('p');
              empty.className = 'h5 text-center';
              empty.textContent = doc.querySelector('[data-search-results-count]')?.textContent || '';
              panel.replaceChildren(empty);
            }
          }
          const numericCount = Number(count);
          target.textContent = '(' + count + ')';
          target.hidden = false;
          if (numericCount === 0) {
            tab.hidden = true;
            tab.setAttribute('aria-hidden', 'true');
            if (panel) panel.hidden = true;
          } else {
            tab.hidden = false;
            tab.removeAttribute('aria-hidden');
          }
          return numericCount;
        } catch (_) {
          return null;
        }
      }));
      if (counts.every(count => count !== null)) {
        const visibleTabs = tabs.filter((tab, index) => counts[index] > 0);
        const selectedTab = tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
        if (selectedTab?.hidden && visibleTabs.length > 0) {
          requestAnimationFrame(() => visibleTabs[0].click());
        }
        const total = counts.reduce((sum, count) => sum + count, 0);
        const heading = summary.querySelector('[data-search-results-count]');
        if (heading) {
          heading.dataset.searchResultsCount = String(total);
          const template = summary.querySelector(total === 0 ? '[data-search-count-zero]' : total === 1 ? '[data-search-count-one]' : '[data-search-count-other]');
          if (template) heading.textContent = template.content.textContent.trim().replace(/^2(?=\D|$)/, String(total));
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && (node.matches('[data-gk-search-summary]') || node.querySelector('[data-gk-search-summary]'))) init(node);
    }
  }).observe(document.documentElement, {childList:true,subtree:true});
}

  } catch(e) { console.error(e); }
})();
})();
